<template>
  <div class>
    <!-- 상단 고정 캠페인 배너 -->
    <div v-if="campaignData &&
      campaignData.dynamicLink &&
      campaignData.locationValue === null
      ">
      <a :href="campaignData.dynamicLink.shortLink" target="_blank">
        <img :src="campaignData.image" :alt="campaignData.dynamicLink.name" />
      </a>
    </div>

    <div class="bg-white pdt-16 pdb-20 bg-documentGray">
      <div class="bg-white graphWrapper pdt-16 pdb-16 pdl-16 pdr-16" v-if="memberTotalPoint">
        <div class="header-card">
          <div class="t-headline2 t-center t-color-title t-size70 pdl-16 pdr-16 pdt-50 pdb-30">
            {{ memberTotalPoint.present }}
          </div>
          <div class="t-body3 t-center t-color-gray2">{{ $t("1894") }}</div>
        </div>
        <div class="d-flex align-items-center justify-content-center mgt-32 mgb-28">
          <div v-if="isNoData1" href="javascript:void(0)"
            class="pdt-7 pdb-8 pdl-11 pdr-11 mgr-8 link-all t-body4 font-r l-spacing12" @click="move('ALL')"
            :class="graphResultType === 'ALL' ? 'link-all' : 'link-inActive'"
            :style="graphResultType !== 'ALL' ? 'color:#313d4b' : 'color:#313d4b'">
            {{ $t("S20123") }}
          </div>
          <div v-if="isNoData1" href="javascript:void(0)"
            class="pdt-7 pdb-8 pdl-11 pdr-11 mgr-8 link-green t-body4 font-r l-spacing12" @click="move('EARN')"
            :class="graphResultType === 'EARN' ? 'link-green' : 'link-inActive'"
            :style="graphResultType !== 'EARN' ? 'color:#313d4b' : 'color:#70cfc8'">
            {{ $t("1896") }}
          </div>
          <div v-if="isNoData1" href="javascript:void(0)"
            class="l-spacing12 pdt-7 pdb-8 pdl-11 pdr-11 font-r link-red t-body4" @click="move('LOSE')"
            :class="graphResultType === 'LOSE' ? 'link-red' : 'link-inActive'"
            :style="graphResultType !== 'LOSE' ? 'color:#313d4b' : 'color:#ff847b'">
            {{ $t("1897") }}
          </div>

          <div v-if="!isNoData1" href="javascript:void(0)"
            class="pdt-7 pdb-8 pdl-11 pdr-11 mgr-8 t-body4 font-r l-spacing12"
            :class="graphResultType === 'ALL' ? 'link-all' : 'link-inActive'"
            :style="graphResultType !== 'ALL' ? 'color:#313d4b' : 'color:#313d4b'" @click="move('ALL')">
            {{ $t("S20123") }}
          </div>
          <div v-if="!isNoData1" href="javascript:void(0)"
            class="pdt-7 pdb-8 pdl-11 pdr-11 mgr-8 t-body4 font-r l-spacing12"
            :class="graphResultType === 'EARN' ? 'link-green' : 'link-inActive'" @click="move('EARN')"
            :style="graphResultType !== 'EARN' ? 'color:#313d4b' : 'color:#70cfc8'">
            {{ $t("1896") }}
          </div>
          <div v-if="!isNoData1" href="javascript:void(0)" class="l-spacing12 pdt-7 pdb-8 pdl-11 pdr-11 font-r t-body4"
            :class="graphResultType === 'LOSE' ? 'link-red' : 'link-inActive'" @click="move('LOSE')"
            :style="graphResultType !== 'LOSE' ? 'color:#313d4b' : 'color:#ff847b'">
            {{ $t("1897") }}
          </div>
        </div>
        <div class="graph border-bottom" v-if="graphResult">
          <line-chart :chart-data="graphResult" :height="150"></line-chart>
        </div>
      </div>

      <div class="pdl-8 pdr-8">
        <div class="flex-row pdt-16 mgb-1 d-flex justify-content-between align-items-baseline pdl-16 pdr-16"
          v-if="memberTotalPoint">
          <p class="mgb-8 mgt-1 font-b t-color-title t-subtitle2">
            {{ $t("1898") }}
          </p>
        </div>

        <div v-for="(pointList, index) in listData" :key="index" class="pdl-8 pdr-8">
          <!-- 목록 캠페인 카드 -->
          <ListItem :pointList="pointList" :myStatus="myStatus"></ListItem>
        </div>
      </div>

      <infinite-loading @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
        <div slot="no-more" class="mgt-16"></div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import pointApi from "@/api/pointApi.js";
import memberApi from "@/api/memberApi.js";
import campaignApi from "@/api/campaignApi.js";
import ListItem from "./ListItem.vue";
import InfiniteLoading from "vue-infinite-loading";
import LineChart from "./charts/LineChart";

export default {
  components: {
    ListItem,
    InfiniteLoading,
    LineChart,
  },

  data() {
    return {
      status: "",
      isNoData: false,
      isNoData1: true,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      mine: "",
      myStatus: "",
      infiniteId: +new Date(),
      graphResult: null,
      memberTotalPoint: 0,
      graphResultType: "ALL"
    };
  },

  computed: {},

  watch: {
    $route(to, from) {
      if (to.query.type && to.query.type.length === 0) {
        this.isNoData1 = true;
      }

      if (to.query.type === "EARN") {
        this.isNoData1 = false;
      }
      if (to.query.type === "LOSE") {
        this.isNoData1 = false;
      }

      this.initData();
      this.myStatus = to.query.type;
    },
  },

  mounted() {
    // 기본 파라미터 설정(set default parameter)
    if (this.$route.query.type && this.$route.query.type.length === 0) {
      this.isNoData1 = true;
    }

    if (this.$route.query.type === "EARN") {
      this.isNoData1 = false;
    }
    if (this.$route.query.type === "LOSE") {
      this.isNoData1 = false;
    }

    if (!this.$route.query.type) {
      this.$router.push("/point");
      this.myStatus = this.$route.query.type;
    } else {
      this.myStatus = this.$route.query.type;
    }

    this.graphResultType = this.$route.query.type ? this.$route.query.type : "ALL";
  },

  methods: {
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let memberTotalPoint = null;
      memberApi
        .memberPoint()
        .then((response) => {
          this.memberTotalPoint = response.data.data;
        })
        .catch((err) => { });

      pointApi
        .getPointForGraph()
        .then((response) => {
          let getGraphResponseData = response.data.data;
          this.drawGraph(getGraphResponseData);
        })
        .catch((err) => { });

      let responseData = null;
      let params = this.setParams();

      if (this.totalPages >= this.currentPage) {
        pointApi
          .pointList(params)
          .then((response) => {
            responseData = response.data.data;
            this.listData = this.listData.concat(responseData.content);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
            //this.drawGraph(responseData);
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }

      // 캠페인 테이터 API 호출(get campaign data)
      let locationType =
        this.$route.query.status === "LEARNING"
          ? "LEARN_IN_PROGRESS_DEGREE"
          : "LEARN_COMPLETED_DEGREE";
      campaignApi
        .campaign({ locationType: locationType })
        .then((response) => {
          this.campaignData = response.data.data;
        })
        .catch((err) => { });
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        type: this.$route.query.type,
        page: this.currentPage,
        size: 10,
      };
      return params;
    },

    drawGraph(res) {
      let response = res,
        earnPoint = [],
        losePoint = [],
        lables = [];

      const graphDates = {};
      Object.keys(response.point).sort((a, b) => {
        return (new Date(a)).getTime() - (new Date(b)).getTime();
      }).forEach((key) => {
        graphDates[key] = response.point[key];
      })

      for (let i in graphDates) {
        lables.push(this.$moment(i).format("M/D"));
        if(this.graphResultType=='ALL'){
          earnPoint.push(response.point[i][0].earn);
          losePoint.push(response.point[i][0].lose);
        } else if(this.graphResultType=='EARN') {
            earnPoint.push(response.point[i][0].earn);
        } else if(this.graphResultType=='LOSE') {
            losePoint.push(response.point[i][0].lose);
        } else {
          earnPoint.push(response.point[i][0].earn);
          losePoint.push(response.point[i][0].lose);
        }
     }

      let finalResult = {
        labels: lables,
        datasets: [
          {
            lineTension: 0.1,
            backgroundColor: 'rgba(112, 207, 200, 0.1)',
            borderWidth: 3,
            borderColor: '#70cfc8',
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            fill: false,
            data: earnPoint
          },
          {
            lineTension: 0.1,
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            borderColor: "rgba(255, 99, 132, 1)",
            borderWidth: 3,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            fill: false,
            data: losePoint
          }
        ],
      };

      this.graphResult = finalResult;
    },
    // 학습진행률 노출 상태 설정(set/toggle learning status graph)
    initProgressStatus(id) {
      _.map(this.listData, (o) => {
        o.id === id && o.progressViewStatus === false
          ? (o.progressViewStatus = true)
          : (o.progressViewStatus = false);
      });
    },
    move(type) {
      this.graphResultType = type;
      if (type === "ALL") {
        this.$router.push({
          name: "Point",
        });
      } else {
        this.$router.push({
          name: "Point",
          query: {
            type,
          },
        });
      }
    },
    setParams() {
      const params = {
        type: this.$route.query.type,
        page: this.currentPage,
        size: 10,
      };
      return params;
    },
  },
};
</script>

<style scoped>
.rewardTitle {
  font-size: 16px;
}

.crown226 {
  max-width: 226px;
}

.shadow135 {
  max-width: 135px;
  height: 30px;
}

.t-size70 {
  font-size: 70px;
  font-weight: 600;
  line-height: 0.29;
}

.link-all {
  border-radius: 18px;
  border: solid 1px #313d4b;
  background-color: #eeeeee;
}

.link-green {
  border-radius: 18px;
  border: solid 1px #70cfc8;
  background-color: rgba(112, 207, 200, 0.1);
}

.link-red {
  border-radius: 18px;
  border: solid 1px #ff847b;
  background-color: rgba(241, 109, 112, 0.1);
}

.border-bottom {
  border-bottom: 1px solid #f1f1f1;
}

.graphWrapper {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background: white;
}

.l-spacing12 {
  letter-spacing: -0.12px !important;
}

.link-inActive {
  border-radius: 18px;
  border: solid 1px rgba(49, 61, 75, 0.2);
  background-color: #ffffff;
}
.bg-documentGray {
  background-color: #f9f9f9;
}
</style>